function DevicesListController(ConditionService, eventService) {
  const ctrl = this;

  ctrl.$onInit = () => {
  };

  ctrl.displayCIList = asset => {
    ctrl.onSelect({
      $event: {
        asset: asset,
      },
    });
  };

  ctrl.updateAssets = async () => {
    ctrl.updatedAssets = await ConditionService.getCategoryData({
      carId: ctrl.subsystem.carNumber,
      category: ctrl.subsystem.name
    });
  }
  
  eventService.on('update-device-list', function(event) {
    ctrl.updateAssets().then(function () {
      for (let i = 0; i < ctrl.updatedAssets.length; i++) {
        ctrl.assets[i] = ctrl.updatedAssets[i];
      }
    });
  });
}

angular
  .module('modalDirectives')
  .controller('DevicesListController', DevicesListController);
